const initialState = {
	isLoading: false,
	showAdopted: false,

	dogsById: {},
	catsById: {},
	otherById: {},
	allAnimalsById: {},
	allAnimalsIds: [],
	filteredAnimalsIds: [],

	adoptedDogsById: {},
	adoptedCatsById: {},
	adoptedOtherById: {},
	allAdoptedAnimalsById: {},
	allAdoptedAnimalsIds: [],
	filteredAdoptedAnimalsIds: [],

	animalsType: 'dog',
	selected: false,
	selectedLast: false,
	filters: {
		size: '',
		shelter: '',
		age_range: '',
		coat_type: '',
		breed: '',
		sex: '',
		good_with_dogs: false,
		good_with_cats: false,
		lived_with_children: false,
		bonded_pair: false,
		special_needs: false
	},
	search: '',
	postcode: '',
	postcodeDistance: 50,
	postcodeLatLng: '',
	happyTailsById: {},
	tributesById: {},
	storiesById: {}
}

function toRad( x ) {
	return x * Math.PI / 180
}

function haversineDistance( lat1, lng1, lat2, lng2 ) {
	let earthRadius = 6371, // km
		latDifference = lat2 - lat1,
		latDifferenceRad = toRad( latDifference ),
		lngDifference = lng2 - lng1,
		lngDifferenceRad = toRad( lngDifference )

	let a = Math.sin( latDifferenceRad / 2 ) * Math.sin( latDifferenceRad / 2 ) +
		Math.cos( toRad( lat1 ) ) * Math.cos( toRad( lat2 ) ) *
		Math.sin( lngDifferenceRad / 2 ) * Math.sin( lngDifferenceRad / 2 )

	let c = 2 * Math.atan2( Math.sqrt( a ), Math.sqrt( 1 - a ) )
	let distance = earthRadius * c

	return distance
}

function filterAnimals( state, allAnimalsIds, allAnimalsById ) {
	let searchTerm = state.search.toLowerCase()

	if ( ! allAnimalsIds.length || ! Object.keys( allAnimalsById ).length ) {
		return []
	}

	let filteredAnimalsIds = allAnimalsIds
		.filter( id => {
			if ( ! allAnimalsById[ id ] ) {
				return false
			}

			// Check type:
			if ( 'any' != state.animalsType && allAnimalsById[ id ]['type'] != state.animalsType ) {
				return false
			}

			// Check search term:
			if ( searchTerm ) {
				let name = allAnimalsById[ id ]['name'].toLowerCase()

				if ( name.indexOf( searchTerm ) == -1 ) {
					return false
				}
			}

			// Check distance:
			if ( state.postcodeLatLng && state.postcodeLatLng['lat'] ) {
				let latLng = allAnimalsById[ id ]['lat_lng']

				if ( ! latLng ) {
					return false
				}

				let lat = latLng[0]
				let lng = latLng[1]

				let distance = haversineDistance( lat, lng, state.postcodeLatLng['lat'], state.postcodeLatLng['lng'] )

				if ( isNaN( distance ) || distance > state.postcodeDistance ) {
					return false
				}
			}

			// Check filters:
			if ( ! state.filters ) {
				return true
			}

			// Include if it matches each filter:
			const passes = Object.keys( state.filters ).every( ( filterId, index ) => {
				return ( ! state.filters[ filterId ] || ! allAnimalsById[ id ] ) || allAnimalsById[ id ][ filterId ] == state.filters[ filterId ]
			})

			if ( ! passes ) {
				return false
			}

			return true
		})

	return filteredAnimalsIds
}

export default function reducer( state = initialState, action ) {
	const { payload } = action
	var filteredAnimalsIds = [],
		filteredAdoptedAnimalsIds = []
	let ids,
		newState,
		passes,
		searchTerm,
		stateForFilterFunction

	switch ( action.type ) {
		case 'SHOW_ADOPTED':
			return {
				...state,
				showAdopted: payload
			}

		case 'REQUEST_ANIMALS_DATA':
			return {
				...state,
				isLoading: true
			}

		case 'RECEIVE_ANIMALS_DATA':
			// Get ids in array:
			ids = Object.keys( payload.data.items ).map( key => {
				return payload.data.items[ key ].id
			})

			let allAnimalsIds = [
				...state.allAnimalsIds,
				...ids
			]

			let allAnimalsById = {
				...state.allAnimalsById,
				...payload.data.items
			}

			// Add extra bonded partners:
			Object.keys( payload.data.items ).map( key => {
				let item = payload.data.items[ key ]

				if ( item.bonded_partner ) {
					allAnimalsById[ item.bonded_partner.id ] = item.bonded_partner
				}
			} )

			// Update filtered ids, respecting current type and filters:
			if ( state.animalsType ) {
				filteredAnimalsIds = filterAnimals( state, allAnimalsIds, allAnimalsById )
			}

			newState = {
				...state,
				isLoading: false,
				allAnimalsIds: allAnimalsIds,
				filteredAnimalsIds: filteredAnimalsIds,
				allAnimalsById: allAnimalsById
			}

			if ( 'cat' == payload.animalType ) {
				newState = {
					...newState,
					catsById: payload.data.items
				}
			} else if ( 'other' == payload.animalType ) {
				newState = {
					...newState,
					otherById: payload.data.items
				}
			} else {
				newState = {
					...newState,
					dogsById: payload.data.items
				}
			}

			return newState

		case 'RECEIVE_ADOPTED_ANIMALS_DATA':
			// Get ids in array:
			ids = Object.keys( payload.data.items ).map( key => {
				return payload.data.items[ key ].id
			})

			let allAdoptedAnimalsIds = [
				...state.allAdoptedAnimalsIds,
				...ids
			]

			let allAdoptedAnimalsById = {
				...payload.data.items
			}

			// Update filtered ids, respecting current type and filters:
			if ( state.animalsType ) {
				filteredAdoptedAnimalsIds = filterAnimals( state, allAdoptedAnimalsIds, allAdoptedAnimalsById )
			}

			newState = {
				...state,
				isLoading: false,
				allAdoptedAnimalsIds: allAdoptedAnimalsIds,
				filteredAdoptedAnimalsIds: filteredAdoptedAnimalsIds,
				allAdoptedAnimalsById: allAdoptedAnimalsById,
				maxPages: payload.data.max_num_pages
			}

			if ( 'cat' == payload.animalType ) {
				newState = {
					...newState,
					adoptedCatsById: payload.data.items
				}
			} else if ( 'other' == payload.animalType ) {
				newState = {
					...newState,
					adoptedOtherById: payload.data.items
				}
			} else {
				newState = {
					...newState,
					adoptedDogsById: payload.data.items
				}
			}

			return newState

		case 'SET_ANIMALS_TYPE':
			if ( state.allAnimalsIds ) {
				filteredAnimalsIds = state.allAnimalsIds
					.filter( id => {
						// Check type:
						if ( 'any' != payload && state.allAnimalsById[ id ]['type'] != payload ) {
							return false
						}

						return true
					})
			}

			if ( state.showAdopted && state.allAdoptedAnimalsIds ) {
				filteredAdoptedAnimalsIds = state.allAdoptedAnimalsIds
			}

			return {
				...state,
				animalsType: payload,
				filteredAnimalsIds: filteredAnimalsIds,
				filteredAdoptedAnimalsIds: filteredAdoptedAnimalsIds,
				filters: {
					size: '',
					shelter: '',
					age_range: '',
					coat_type: '',
					breed: '',
					sex: '',
					good_with_dogs: false,
					good_with_cats: false,
					lived_with_children: false,
					bonded_pair: false,
					special_needs: false
				},
				search: '',
				postcode: ''
			}

		case 'SET_SELECTED_ANIMAL':
			let selected = state.selected,
				selectedLast = state.selectedLast

			if ( ! payload ) {
				selected = false
			} else if ( state.allAnimalsById[ payload ] ) {
				selected = state.allAnimalsById[ payload ]
				selectedLast = state.allAnimalsById[ payload ]
			}

			return {
				...state,
				selected: selected,
				selectedLast: selectedLast
			}

		case 'SET_ANIMALS_SEARCH':
			filteredAnimalsIds = []

			stateForFilterFunction = {
				...state,
				search: payload
			}

			if ( state.allAnimalsIds ) {
				filteredAnimalsIds = filterAnimals( stateForFilterFunction, state.allAnimalsIds, state.allAnimalsById )
			}

			if ( state.showAdopted && state.allAdoptedAnimalsIds ) {
				filteredAdoptedAnimalsIds = filterAnimals( stateForFilterFunction, state.allAdoptedAnimalsIds, state.allAdoptedAnimalsById )
			}

			return {
				...state,
				search: payload,
				filteredAnimalsIds: filteredAnimalsIds,
				filteredAdoptedAnimalsIds: filteredAdoptedAnimalsIds
			}

		case 'SET_ANIMALS_POSTCODE':
			return {
				...state,
				postcode: payload
			}

		case 'SET_ANIMALS_POSTCODE_DISTANCE':
			return {
				...state,
				postcodeDistance: payload
			}

		case 'SET_LAT_LNG':
			filteredAnimalsIds = []
			let postcodeLatLng = payload

			stateForFilterFunction = {
				...state,
				postcodeLatLng: postcodeLatLng
			}

			if ( state.allAnimalsIds ) {
				filteredAnimalsIds = filterAnimals( stateForFilterFunction, state.allAnimalsIds, state.allAnimalsById )
			}

			if ( state.showAdopted && state.allAdoptedAnimalsIds ) {
				filteredAdoptedAnimalsIds = filterAnimals( stateForFilterFunction, state.allAdoptedAnimalsIds, state.allAdoptedAnimalsById )
			}

			return {
				...state,
				postcodeLatLng: postcodeLatLng,
				filteredAnimalsIds: filteredAnimalsIds,
				filteredAdoptedAnimalsIds: filteredAdoptedAnimalsIds
			}


		case 'SET_ANIMALS_FILTER':
			let filters = {
					...state.filters,
					[ payload.id ]: payload.value
				}

			stateForFilterFunction = {
				...state,
				filters: filters
			}

			if ( state.allAnimalsIds ) {
				filteredAnimalsIds = filterAnimals( stateForFilterFunction, state.allAnimalsIds, state.allAnimalsById )
			}

			if ( state.showAdopted && state.allAdoptedAnimalsIds ) {
				filteredAdoptedAnimalsIds = filterAnimals( stateForFilterFunction, state.allAdoptedAnimalsIds, state.allAdoptedAnimalsById )
			}

			return {
				...state,
				filters: filters,
				filteredAnimalsIds: filteredAnimalsIds,
				filteredAdoptedAnimalsIds: filteredAdoptedAnimalsIds
			}

		case 'RECEIVE_HAPPY_TAILS_DATA':
			return {
				...state,
				happyTailsById: payload.data.items
			}

		case 'RECEIVE_TRIBUTES_DATA':
			return {
				...state,
				tributesById: payload.data.items
			}

		case 'RECEIVE_STORIES_DATA':
			return {
				...state,
				storiesById: payload.data.items
			}
	}

	return state
}



// WEBPACK FOOTER //
// ./redux/reducers/animals.jsx